import { Component } from '@angular/core';
import { SessionService } from '../../../authentication/session.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { whiteLabelTarget } from 'src/app/utils/whiteLabel';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: [
    './signup.component.css',
    '../login/login.component.css',
    '../../login/login.component.css',
  ],
})
export class SignupOrganicComponent {
  constructor(
    private sessionService: SessionService,
    private fb: FormBuilder,
    private route: Router,
    private titleService: Title,
    private localStorageService: LocalStorageService,
  ) {}

  loginLoading: boolean = false;

  form = this.fb.group({
    fullname: ['', Validators.required],
    email: ['', Validators.required],
    password: ['', Validators.required],
  });

  moreInfo: string = '';

  isRedirectedFromWeb: boolean = false;

  whiteLabelTarget = whiteLabelTarget;

  ngOnInit() {
    document.body.classList.remove('dark-theme');

    if (this.whiteLabelTarget) {
      this.titleService.setTitle(
        this.whiteLabelTarget.description + 'Dashboard',
      );
    } else {
      this.titleService.setTitle('Signup - Organic');
    }
  }
  showPassword: boolean = false;
  toogleShowPassword() {
    this.showPassword = !this.showPassword;
  }
  signup() {
    this.loginLoading = true;
    if (this.form.valid) {
      this.sessionService.signup(this.form.value).subscribe({
        next: (res) => {
          if (res?.message.toLocaleLowerCase() == 'success') {
            this.pushAdsData(false, null);

            this.sessionService
              .authenticated(
                this.form.value?.email?.toLowerCase() || '',
                this.form.value?.password || '',
              )
              .subscribe({
                next: (data: any) => {
                  if (data['status'] == 3) {
                    this.loginLoading = false;
                    this.localStorageService.set('organicLogin', true);
                    this.localStorageService.set('organic_signup', true);
                    this.sessionService.login(data);

                    this.route.navigate(['organic_onboarding']);
                    // this.route.navigate(['seo/billing']);
                  } else {
                    this.moreInfo = 'Something went wrong!';
                  }
                },
              });
          } else {
            if (res?.message) {
              this.moreInfo = res?.message;
            } else {
              this.moreInfo = 'Something went wrong!';
            }
          }
        },
        error: (error) => {
          this.loginLoading = false;
          this.moreInfo = 'Something went wrong!';
        },
      });
    }
  }

  pushAdsData(fromGoogle: any, result: any) {
    if (
      this.localStorageService.get('gclid_from_web') ||
      this.localStorageService.get('fbclid_from_web')
    ) {
      const sessionID = JSON.parse(
        (window as any).behamics._getCookie(
          (window as any).behamics.variables.userStorageKey,
        ),
      ).sessionID;

      const data = {
        fullname: !fromGoogle ? this.form.value?.fullname : result.user.name,
        sessionID: sessionID,
        Product: 'Organic',
        adType: 'google', // or "facebook"
        utm_source: this.localStorageService.get('utm_source_from_web') || '',
        utm_medium: this.localStorageService.get('utm_medium_from_web') || '',
        utm_campaign:
          this.localStorageService.get('utm_campaign_from_web') || '',
        event_type: 'signup',
        gclid: this.localStorageService.get('gclid_from_web') || '',
        fbclid: this.localStorageService.get('fbclid_from_web') || '',
        email: !fromGoogle ? this.form.value?.email : result.user.email,
        seo_url: this.localStorageService.get('seo_url_from_web') || '',
      };

      this.sessionService.pushAdsData(data).subscribe((res) => {
        console.log(res);
      });
    }
  }

  loginWithGoogle(event: any) {
    event.preventDefault();
    const popup = window.open(
      'https://api.dashboard.behamics.com/api/auth/google?origin=' +
        location.origin,
      'googleAuth',
      'popup=1,width=600,height=700',
    );
    window.addEventListener(
      'message',
      (event) => {
        if (event.data.type === 'GoogleLogin') {
          const { result } = event.data;
          if (result) {
            popup?.close();
            if (result.status === 3) {
              this.localStorageService.set('organicLogin', true);
              this.localStorageService.set('organic_signup', true);

              this.pushAdsData(true, result);

              this.sessionService.login(result);

              if (this.isRedirectedFromWeb) {
                this.route.navigate(['organic_onboarding']);
              } else {
                this.sessionService.navigate(result);
              }
              this.moreInfo = '';
              this.loginLoading = false;
            } else {
              this.moreInfo = result.message;
              this.loginLoading = false;
            }
          }
        }
      },
      { once: true },
    );
  }
  redirectToLogin() {
    this.route.navigate(['login_organic']);
  }

  showInputs: boolean = false;
  loginWithEmail(event: any) {
    if (!this.showInputs) {
      event.preventDefault();
      this.showInputs = true;
      return;
    }
  }
  privatcyPolicyClick() {
    window.open('https://behamics.com/legal/privacy-policy-en.pdf', '_blank');
  }
}
